import { useReducer, useEffect, useCallback } from "react";
import chargerConfigReducer, { initialState as reducerInitialState } from "./reducer";
import { fetchChargerConfig, sendOcppCommand } from "./api";
import ACTIONS from "./actions";

const FETCH_DEBOUNCE_MS = 1000;

async function getChargerConfig(dispatch, chargerId) {
  dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_INIT });
  try {
    const res = await fetchChargerConfig(chargerId);
    dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_SUCCESS, payload: res });
  } catch (e) {
    dispatch({ type: ACTIONS.FETCH_CHARGER_CONFIG_FAILURE });
  }
}

async function sendCommand(dispatch, payload) {
  dispatch({ type: ACTIONS.SEND_OCPP_COMMAND_INIT });
  try {
    const res = await sendOcppCommand(payload);
    dispatch({ type: ACTIONS.SEND_OCPP_COMMAND_SUCCESS, payload: res });
    return res;
  } catch (e) {
    dispatch({ type: ACTIONS.SEND_OCPP_COMMAND_FAILURE });
    throw e;
  }
}

export function useChargerConfig(_siteId, chargerId) {
  const [state, dispatch] = useReducer(chargerConfigReducer, reducerInitialState);

  useEffect(() => {
    // Clear stale data immediately so the UI shows a skeleton during debounce
    dispatch({ type: ACTIONS.RESET_CHARGER_CONFIG });

    const handler = setTimeout(() => {
      if (chargerId) {
        getChargerConfig(dispatch, chargerId);
      }
    }, FETCH_DEBOUNCE_MS);
    return () => clearTimeout(handler);
  }, [chargerId]);

  return {
    config: state.data,
    loading: state.isLoading,
    error: state.isError,
    hasFetched: state.hasFetched,
    dispatch,
    sendCommand: useCallback(payload => sendCommand(dispatch, payload), [dispatch]),
  };
}

export default useChargerConfig;
